export const SESSION_STORAGE_KEYS = {
  IMPERSONATION_USER: 'impersonationUser',
  SSO_REDIRECT_URL: 'sso_redirect_url',
};
